import React, {useEffect} from "react";
import {makeStyles} from "@mui/styles";
import {useDispatch, useSelector} from "react-redux";
import queryString from "query-string";
import {searchRecipeDebounce} from "../../../data/Recipe/RecipeHelper";
import {useLocation} from "react-router-dom";
import {SearchForRecipe} from "../../../Store/reducers/recipeReducer";
import {MuiChipsInput} from "mui-chips-input";
import {addAlert} from "../../../Store/reducers/alertReducer";
import {Box} from "@mui/material";
import {USER} from "../../../Store/reducers/globalReducer";

const useStyles = makeStyles(theme => ({
    appBar: {
        zIndex: theme?.zIndex?.drawer + 1,
    },
    background: {
        width: "100%",
        backgroundColor: '#f5f5f5'
    }

}));


export default function SearchBar({userID}) {
    const classes = useStyles();
    const location = useLocation();
    const dispatcher = useDispatch()
    const searchText = useSelector(state => state.recipe.searchText)
    const recipeUser = useSelector(state => state.global.recipeUser)


    useEffect(() => {
            const searchParams = queryString.parse(location.search);
            if (searchParams.type) {
                dispatcher({type: SearchForRecipe, payload: searchParams})
            } else {
                searchRecipeDebounce("", dispatcher, userID)
            }
        }
        , [location, userID, dispatcher])


    function handleChipChange(newChips) {
        if(recipeUser===USER){
            addAlert(dispatcher,"We currently do not support user search! Don't worry, this will be added soon", "error")
            return;
        }

        if (newChips.length > 1) {
            addAlert(dispatcher, "Currently we only support 1 search term, please delete before searching", "error")
            return;
        }

        const newSearchText = newChips.length > 0 ? newChips[newChips.length - 1] : "";
        searchRecipeDebounce(newSearchText, dispatcher, userID)
    }

    return (
        <Box style={{display:"flex", flexDirection:"column"}}>
        <MuiChipsInput
                   className={classes.background}
                   placeholder={"Search"}
                   value={searchText ? [searchText] : []}
                   onChange={handleChipChange}
        />
        </Box>
    )
}